module.exports = __webpack_public_path__ + "media/images/voice02-2-ce2e9c157bf00d5cbadf2319cb9b9c76.jpg";